import React from 'react';
import { Box, Pagination, useMediaQuery, useTheme } from '@mui/material';

const CustomPagination = ({
  totalPages = 1,
  currentPage = 0,
  onPageChange,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleChange = (event, page) => {
    if (onPageChange) {
      onPageChange(page - 1);
    }
  };

  if (totalPages <= 1) return null;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: { xs: 2, sm: 3 } }}>
      <Pagination
        count={totalPages}
        page={currentPage + 1}
        onChange={handleChange}
        color="primary"
        showFirstButton={!isMobile}
        showLastButton={!isMobile}
        size={isMobile ? "small" : "medium"}
        siblingCount={isMobile ? 0 : 1}
        boundaryCount={isMobile ? 1 : 1}
      />
    </Box>
  );
};

export default CustomPagination;
